import { ProjectMemberStatus } from "../../containers/TeamSettings/container/Projects/ProjectsMembers/types";
import { IMemberList } from "./types";

export function getMembersByIds(
  members: IMemberList[],
  ids: string | string[]
): IMemberList[] {
  if (!Array.isArray(members) || !ids) return [];

  const idArray = Array.isArray(ids) ? ids : [ids];
  return members.filter((m) => idArray.includes(m._id));
}

export const filterActiveTeamMembers = (members: IMemberList[] = []) => {
  return members.filter(
    (member) => (member.status as unknown as ProjectMemberStatus) === ProjectMemberStatus.ACTIVE
  );
};


export const filterAvailableMembers = (
  allMembers: IMemberList[] = [],
  projectMembers: IMemberList[] = [] 
) => {

  const existingIds = new Set(projectMembers.map(m => m._id || m._id));
  const existingEmails = new Set(projectMembers.map(m => m.email));

  return allMembers.filter((member) => {

    const isActive = (member.status as unknown as ProjectMemberStatus) === ProjectMemberStatus.ACTIVE;


    const isNotAlreadyInProject = !existingIds.has(member._id) && !existingEmails.has(member.email);

    return isActive && isNotAlreadyInProject;
  });
};